import React, { Component } from "react"
import { fade, withStyles } from "@material-ui/core/styles"
import TreeView from "@material-ui/lab/TreeView"
import TreeItem from "@material-ui/lab/TreeItem"
import Collapse from "@material-ui/core/Collapse"
import { animated } from "react-spring/web.cjs" // web.cjs is required for IE 11 support
import { navigate } from "gatsby"

import "./menu.scss"

function TransitionComponent(props) {
  return (
    <animated.div>
      <Collapse {...props} />
    </animated.div>
  )
}

const StyledTreeItem = withStyles((theme) => {
  return {
    iconContainer: {
      "& .close": {
        opacity: 0.3,
      },
    },
    group: {
      marginLeft: 33,
      paddingLeft: 33,
    },
    root: {
      borderLeft: `2px solid ${fade("#B8B8B8", 1)}`,
      boxSizing: "border-box",
      paddingLeft: 11,
    },
    selected: {
      // color: `#EC3F2B`,
      fontWeight: `bolder`,
      borderLeft: `2px solid ${fade("rgb(236, 63, 43)", 1)}`,
      boxSizing: "border-box",
    },
  }
})((props) => <TreeItem {...props} TransitionComponent={TransitionComponent} />)

class Menu extends Component {
  renderMenu = (items, level = 0) => {
    return (
      <TreeView
        multiSelect={false}
        selected={
          level === 0
            ? this.props.selected
            : level === 1
            ? this.props.selected2
            : level === 2
            ? this.props.selected3
            : ""
        }
        expanded={
          level === 0
            ? [this.props.selected]
            : level === 1
            ? [this.props.selected2]
            : []
        }
        style={this.props.color ? { color: this.props.color } : null}
      >
        {items.map((item, index) => {
          if (item.bool_is_visible) {
            if (item.bool_is_external) {
              return (
                <a
                  href={item.text_page_url}
                  target={"__blank"}
                  rel={"noopener noreferrer"}
                  key={index}
                >
                  <StyledTreeItem
                    nodeId={item.text_page_id}
                    label={item.text_label}
                    className={`border_correction_${level}`}
                  >
                    {item.children && this.renderMenu(item.children, level + 1)}
                  </StyledTreeItem>
                </a>
              )
            } else {
              return (
                <StyledTreeItem
                  nodeId={item.text_page_id}
                  label={item.text_label}
                  className={`border_correction_${level}`}
                  onClick={() =>
                    navigate(item.text_page_url, { state: null, replace: true })
                  }
                  key={index}
                >
                  {item.children && this.renderMenu(item.children, level + 1)}
                </StyledTreeItem>
              )
            }
          } else {
            return null
          }
        })}
      </TreeView>
    )
  }

  render() {
    return (
      <div className="menu">
        <TreeView
          multiSelect={false}
          style={this.props.color ? { color: this.props.color } : null}
        >
          {this.renderMenu(this.props.items)}
        </TreeView>
      </div>
    )
  }
}

export default Menu
